import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export const PrivateRouteAdmin = () => {
  if (localStorage.jwtToken) {
    return <Outlet />;
  }

  return <Navigate to="/" />;
};
